import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import langIsEn from '../../utils/langIsEn';
import styles from './ProjectCol.css';

class ProjectCol extends Component {
  static propTypes = {
    project: PropTypes.object,
  };

  state = {
    isVisible: false,
  }

  onChange(isVisible) {
    if (!this.state.isVisible && isVisible) {
      this.setState({
        isVisible: isVisible,
      });
    }
  }

  render() {
    const { project } = this.props;
    const { isVisible } = this.state;

    return (
      <div className={classnames(
        { 'col--4of12': project.sizeClass === 4 },
        { 'col--8of12': project.sizeClass === 8 },
        { 'col--7of12': project.sizeClass === 7 },
        { 'col--5of12': project.sizeClass === 5 },
      )}>
        <Link to={`/projects/${project.engName}`} className={styles.link}>
          <VisibilitySensor
            onChange={this.onChange.bind(this)}
            partialVisibility={true}
          >
            <img
              className={classnames(styles.img, { 'animated fadeInUp': isVisible })}
              src={project.picURL}
              alt={project.engName}
            />
          </VisibilitySensor>
          <div className={styles.projectInfoContainer}>
            <div className={styles.projectInfo}>
              <p className={styles.tags}>{project.tags.join(', ')}</p>
              <p className={styles.name}>
                <span className={styles.engName}>{project.engName}</span>
                {!langIsEn() && project.chtName && <span className={styles.chtName}>{project.chtName}</span>}
              </p>
            </div>
          </div>
        </Link>
      </div>
    )
  }
}

export default ProjectCol;



// WEBPACK FOOTER //
// ./src/components/project-col/ProjectCol.js